document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeSection_SidebarNav', () => {
    return {
      init() {
        initTeleport(this.$root);
        Alpine.store('modals').register('mobile-sidebar-nav', 'leftDrawer');
      },
    };
  });

  /**
   * Mobile drawer: single list (no tabs). Menu tree is injected on the page as
   * `window.__LM_MOBILE_NAV__[sectionId]` so it works with x-teleport (no JSON parse race).
   */
  Alpine.data('ThemeSection_MobileNavDrawer', (sectionId, hasAccountTab) => ({
    accountMode: false,
    drillStack: [],
    hasAccountTab: hasAccountTab === true || hasAccountTab === 'true',
    menu: [],

    get currentItems() {
      if (this.drillStack.length === 0) return [];
      const frame = this.drillStack[this.drillStack.length - 1];
      return frame.items || [];
    },

    get drillSignature() {
      if (this.drillStack.length === 0) return '';
      return this.drillStack.map((frame, i) => `${i}:${frame.title || ''}`).join('|');
    },

    get drillTitle() {
      if (this.drillStack.length === 0) return '';
      return this.drillStack[this.drillStack.length - 1].title || '';
    },

    get isDrillView() {
      return this.drillStack.length > 0;
    },

    get showBack() {
      return this.drillStack.length > 0 || this.accountMode;
    },

    init() {
      const store = typeof window !== 'undefined' ? window.__LM_MOBILE_NAV__ : null;
      const tree = store && store[sectionId];
      this.menu = Array.isArray(tree) ? tree : [];
    },

    closeAccount() {
      this.accountMode = false;
    },

    goBack() {
      if (this.accountMode) {
        this.closeAccount();
        return;
      }
      if (this.drillStack.length > 0) this.drillStack.pop();
    },

    openAccount() {
      this.accountMode = true;
      this.drillStack = [];
    },

    openTopLink(item) {
      if (!item) return;
      this.accountMode = false;
      if (this.rowHasChildren(item)) {
        this.pushDrill(item);
      } else if (item.url) {
        window.location.href = item.url;
      }
    },

    pushDrill(item) {
      if (!this.rowHasChildren(item)) return;
      this.accountMode = false;
      this.drillStack.push({
        items: item.children,
        title: item.title,
      });
    },

    resetOnOpen() {
      this.accountMode = false;
      this.drillStack = [];
    },

    rowHasChildren(item) {
      return item.children && item.children.length > 0;
    },
  }));
});
